<script lang="ts">
	import { fade } from 'svelte/transition';

  export let text: string;
</script>

<code><span in:fade={{delay: 180, duration: 1000}}>{text}</span></code>

<style lang="scss">
  code {
    color: #ff7b72;
  }
</style>